import { render, staticRenderFns } from "./FreshCustomerListComponent.vue?vue&type=template&id=7bcb9f58"
import script from "./FreshCustomerListComponent.vue?vue&type=script&lang=js"
export * from "./FreshCustomerListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports